export default __webpack_public_path__ + "static/media/SphericalArmImg.4a6c2f0e.png";